import { compareDates } from '@/helpers/utils';
import Vue from 'vue';

export const User = {
    state: {},
    mutations: {},
    getters: {
        getUserId() {
            if (Vue.prototype.$api.getPayload() && Vue.prototype.$api.getPayload().client_id) {
                return Vue.prototype.$api.getPayload().client_id;
            }
        },
        isLoggedIn() {
            return Vue.prototype.$api.isLoggedIn();
        },
        getUser(state, getters, rootState) {
            if (rootState.deha.user) {
                return rootState.deha.user;
            }
            return null;
        },
        getUserMisc(state, getters, rootState) {
            if (rootState.deha.user && rootState.deha.user.misc) {
                return rootState.deha.user.misc;
            }
            return null;
        },
        getUserTestPeriod(state, getters, rootState) {
            if (
                'testzeitraum_bis' in rootState.deha.user &&
                rootState.deha.user.testzeitraum_bis !== null &&
                rootState.deha.user.testzeitraum_bis !== undefined &&
                rootState.deha.user.testzeitraum_bis !== ''
            ) {
                return rootState.deha.user.testzeitraum_bis;
            }
            return null;
        },
        isUserNotAllowed(state, getters, rootState) {
            let now = new Date();
            // check role
            if (
                !rootState.deha.user ||
                !rootState.deha.user.profil ||
                rootState.deha.user.profil !== 'Kunde'
            ) {
                return true;
            }
            // check disabled
            if (
                rootState.deha.user &&
                rootState.deha.user.gesperrt &&
                rootState.deha.user.gesperrt == '1'
            ) {
                return true;
            }
            // check package
            if (
                rootState.deha.user &&
                (!rootState.deha.user.paket || rootState.deha.user.paket == '')
            ) {
                return true;
            }
            // check cancelled
            if (
                rootState.deha.user &&
                rootState.deha.user.gekuendigt &&
                compareDates(rootState.deha.user.gekuendigt, now) === -1
            ) {
                return true;
            }
            // both gebucht/testzeitraum set
            if (
                rootState.deha.user &&
                rootState.deha.user.gebucht &&
                rootState.deha.user.testzeitraum_bis &&
                compareDates(rootState.deha.user.gebucht, now) === 1 &&
                compareDates(rootState.deha.user.testzeitraum_bis, now) === -1
            ) {
                return true;
            }
            // only gebucht set
            if (
                rootState.deha.user &&
                rootState.deha.user.gebucht &&
                !rootState.deha.user.testzeitraum_bis &&
                compareDates(rootState.deha.user.gebucht, now) === 1
            ) {
                return true;
            }
            // only testzeitraum set
            if (
                rootState.deha.user &&
                !rootState.deha.user.gebucht &&
                rootState.deha.user.testzeitraum_bis &&
                compareDates(rootState.deha.user.testzeitraum_bis, now) === -1
            ) {
                return true;
            }
            // nothing set
            if (
                rootState.deha.user &&
                !rootState.deha.user.gebucht &&
                !rootState.deha.user.testzeitraum_bis
            ) {
                return true;
            }
            return false;
        },
        getUserClientId(state, getters, rootState) {
            if (rootState.deha.user && rootState.deha.user.kundennr) {
                return rootState.deha.user.kundennr;
            }
            return null;
        },
        getUserDomain(state, getters, rootState) {
            if (rootState.deha.user && rootState.deha.user.domain) {
                return rootState.deha.user.domain;
            }
            return null;
        },
        getUserDomainUrl(state, getters, rootState) {
            if (rootState.deha.user && rootState.deha.user.domain) {
                let url = window.location.protocol + '//';
                // determine subdomain
                if (window.location.host.indexOf('test.') > -1) {
                    url += 'test.';
                } else if (rootState.deha.user.domain.split('.').length <= 2) {
                    url += 'www.';
                }
                url += rootState.deha.user.domain;
                return url;
            }
            return null;
        },
        needsPrivacyOfficer(state, getters) {
            return getters.getProp('deha.user.misc.needs_privacy_officer') == 1;
        },
        getLegalUserData(state, getters) {
            return {
                firma1: getters.getProp('deha.user.firma1'),
                firmierung: getters.getProp('deha.user.misc.firmierung'),
                strasse: getters.getProp('deha.user.strasse'),
                plz: getters.getProp('deha.user.plz'),
                ort: getters.getProp('deha.user.ort'),
                land: getters.getProp('deha.user.land'),
                telefon: getters.getProp('deha.user.telefon'),
                fax: getters.getProp('deha.user.fax'),
                email: getters.getProp('deha.user.email'),
                ustid: getters.getProp('deha.user.ustid'),
                handelsregisternummer: getters.getProp('deha.user.handelsregisternummer'),
                registergericht: getters.getProp('deha.user.registergericht'),
                contact_person: {
                    first_name: getters.getProp('deha.user.misc.contact_person.first_name'),
                    last_name: getters.getProp('deha.user.misc.contact_person.last_name')
                },
                contact_person_2: {
                    first_name: getters.getProp('deha.user.misc.contact_person_2.first_name'),
                    last_name: getters.getProp('deha.user.misc.contact_person_2.last_name')
                },
                contact_person_3: {
                    first_name: getters.getProp('deha.user.misc.contact_person_3.first_name'),
                    last_name: getters.getProp('deha.user.misc.contact_person_3.last_name')
                },
                privacy_officer: {
                    needed: getters.needsPrivacyOfficer,
                    first_name: getters.getProp('deha.user.misc.privacy_officer.first_name'),
                    last_name: getters.getProp('deha.user.misc.privacy_officer.last_name'),
                    email: getters.getProp('deha.user.misc.privacy_officer.email'),
                    phone: getters.getProp('deha.user.misc.privacy_officer.phone')
                },
                socials: getters.getProp('deha.user.misc.socials'),
                responsible_for_content: {
                    first_name: getters.getProp('deha.user.misc.responsible_for_content.first_name'),
                    last_name: getters.getProp('deha.user.misc.responsible_for_content.last_name'),
                    address: getters.getProp('deha.user.misc.responsible_for_content.address'),
                },
                regulated_profession_applicable: getters.getProp('deha.user.misc.regulated_profession_applicable'),
                regulated_profession: {
                    job_name: getters.getProp('deha.user.misc.regulated_profession.job_name'),
                    chamber_name: getters.getProp('deha.user.misc.regulated_profession.chamber_name'),
                    chamber_link: getters.getProp('deha.user.misc.regulated_profession.chamber_link'),
                },
                regulated_profession_2: {
                    job_name: getters.getProp('deha.user.misc.regulated_profession_2.job_name'),
                    chamber_name: getters.getProp('deha.user.misc.regulated_profession_2.chamber_name'),
                    chamber_link: getters.getProp('deha.user.misc.regulated_profession_2.chamber_link'),
                },
                regulated_profession_3: {
                    job_name: getters.getProp('deha.user.misc.regulated_profession_3.job_name'),
                    chamber_name: getters.getProp('deha.user.misc.regulated_profession_3.chamber_name'),
                    chamber_link: getters.getProp('deha.user.misc.regulated_profession_3.chamber_link'),
                },
            };
        }
    },
    actions: {}
};
